var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6923 2.5C46.2017 2.5 58.8846 15.4221 58.8846 31.5C58.8846 47.5779 46.2017 60.5 30.6923 60.5C15.1829 60.5 2.5 47.5779 2.5 31.5C2.5 15.4221 15.1829 2.5 30.6923 2.5Z",
    fill: "white",
    stroke: "#FB3F26",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5128 29.5C17.6844 29.5 17.0128 30.1716 17.0128 31C17.0128 31.8284 17.6844 32.5 18.5128 32.5L18.5128 29.5ZM42.9581 32.0607C43.5439 31.4749 43.5439 30.5251 42.9581 29.9393L33.4122 20.3934C32.8264 19.8076 31.8766 19.8076 31.2908 20.3934C30.7051 20.9792 30.7051 21.9289 31.2908 22.5147L39.7761 31L31.2908 39.4853C30.7051 40.0711 30.7051 41.0208 31.2908 41.6066C31.8766 42.1924 32.8264 42.1924 33.4122 41.6066L42.9581 32.0607ZM18.5128 32.5L41.8974 32.5L41.8974 29.5L18.5128 29.5L18.5128 32.5Z",
    fill: "#FB3F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.072a527fde7e66897f7371983a910fe4.svg";
export { ForwardRef as ReactComponent };